import { jsx as K, jsxs as ae, Fragment as Qe } from "react/jsx-runtime";
import { c as re, I as et } from "./Section-DOeCOW54.js";
import * as R from "react";
import { forwardRef as tt } from "react";
import { g as nt } from "./_commonjsHelpers-DaMA6jEr.js";
import * as rt from "react-dom";
var Ee = { exports: {} }, se = { exports: {} }, N = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Se;
function ot() {
  if (Se) return N;
  Se = 1;
  var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, t = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, y = e ? Symbol.for("react.forward_ref") : 60112, b = e ? Symbol.for("react.suspense") : 60113, x = e ? Symbol.for("react.suspense_list") : 60120, C = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, O = e ? Symbol.for("react.block") : 60121, j = e ? Symbol.for("react.fundamental") : 60117, F = e ? Symbol.for("react.responder") : 60118, B = e ? Symbol.for("react.scope") : 60119;
  function m(c) {
    if (typeof c == "object" && c !== null) {
      var W = c.$$typeof;
      switch (W) {
        case n:
          switch (c = c.type, c) {
            case d:
            case p:
            case t:
            case o:
            case i:
            case b:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case u:
                case y:
                case h:
                case C:
                case a:
                  return c;
                default:
                  return W;
              }
          }
        case r:
          return W;
      }
    }
  }
  function $(c) {
    return m(c) === p;
  }
  return N.AsyncMode = d, N.ConcurrentMode = p, N.ContextConsumer = u, N.ContextProvider = a, N.Element = n, N.ForwardRef = y, N.Fragment = t, N.Lazy = h, N.Memo = C, N.Portal = r, N.Profiler = o, N.StrictMode = i, N.Suspense = b, N.isAsyncMode = function(c) {
    return $(c) || m(c) === d;
  }, N.isConcurrentMode = $, N.isContextConsumer = function(c) {
    return m(c) === u;
  }, N.isContextProvider = function(c) {
    return m(c) === a;
  }, N.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === n;
  }, N.isForwardRef = function(c) {
    return m(c) === y;
  }, N.isFragment = function(c) {
    return m(c) === t;
  }, N.isLazy = function(c) {
    return m(c) === h;
  }, N.isMemo = function(c) {
    return m(c) === C;
  }, N.isPortal = function(c) {
    return m(c) === r;
  }, N.isProfiler = function(c) {
    return m(c) === o;
  }, N.isStrictMode = function(c) {
    return m(c) === i;
  }, N.isSuspense = function(c) {
    return m(c) === b;
  }, N.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === t || c === p || c === o || c === i || c === b || c === x || typeof c == "object" && c !== null && (c.$$typeof === h || c.$$typeof === C || c.$$typeof === a || c.$$typeof === u || c.$$typeof === y || c.$$typeof === j || c.$$typeof === F || c.$$typeof === B || c.$$typeof === O);
  }, N.typeOf = m, N;
}
var M = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ce;
function it() {
  return Ce || (Ce = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, t = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, y = e ? Symbol.for("react.forward_ref") : 60112, b = e ? Symbol.for("react.suspense") : 60113, x = e ? Symbol.for("react.suspense_list") : 60120, C = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, O = e ? Symbol.for("react.block") : 60121, j = e ? Symbol.for("react.fundamental") : 60117, F = e ? Symbol.for("react.responder") : 60118, B = e ? Symbol.for("react.scope") : 60119;
    function m(l) {
      return typeof l == "string" || typeof l == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      l === t || l === p || l === o || l === i || l === b || l === x || typeof l == "object" && l !== null && (l.$$typeof === h || l.$$typeof === C || l.$$typeof === a || l.$$typeof === u || l.$$typeof === y || l.$$typeof === j || l.$$typeof === F || l.$$typeof === B || l.$$typeof === O);
    }
    function $(l) {
      if (typeof l == "object" && l !== null) {
        var Z = l.$$typeof;
        switch (Z) {
          case n:
            var ie = l.type;
            switch (ie) {
              case d:
              case p:
              case t:
              case o:
              case i:
              case b:
                return ie;
              default:
                var _e = ie && ie.$$typeof;
                switch (_e) {
                  case u:
                  case y:
                  case h:
                  case C:
                  case a:
                    return _e;
                  default:
                    return Z;
                }
            }
          case r:
            return Z;
        }
      }
    }
    var c = d, W = p, L = u, Y = a, z = n, U = y, G = t, X = h, J = C, H = r, Q = o, P = i, w = b, q = !1;
    function ne(l) {
      return q || (q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), s(l) || $(l) === d;
    }
    function s(l) {
      return $(l) === p;
    }
    function f(l) {
      return $(l) === u;
    }
    function v(l) {
      return $(l) === a;
    }
    function E(l) {
      return typeof l == "object" && l !== null && l.$$typeof === n;
    }
    function g(l) {
      return $(l) === y;
    }
    function A(l) {
      return $(l) === t;
    }
    function _(l) {
      return $(l) === h;
    }
    function S(l) {
      return $(l) === C;
    }
    function I(l) {
      return $(l) === r;
    }
    function D(l) {
      return $(l) === o;
    }
    function k(l) {
      return $(l) === i;
    }
    function V(l) {
      return $(l) === b;
    }
    M.AsyncMode = c, M.ConcurrentMode = W, M.ContextConsumer = L, M.ContextProvider = Y, M.Element = z, M.ForwardRef = U, M.Fragment = G, M.Lazy = X, M.Memo = J, M.Portal = H, M.Profiler = Q, M.StrictMode = P, M.Suspense = w, M.isAsyncMode = ne, M.isConcurrentMode = s, M.isContextConsumer = f, M.isContextProvider = v, M.isElement = E, M.isForwardRef = g, M.isFragment = A, M.isLazy = _, M.isMemo = S, M.isPortal = I, M.isProfiler = D, M.isStrictMode = k, M.isSuspense = V, M.isValidElementType = m, M.typeOf = $;
  }()), M;
}
var Oe;
function qe() {
  return Oe || (Oe = 1, process.env.NODE_ENV === "production" ? se.exports = ot() : se.exports = it()), se.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var de, Pe;
function st() {
  if (Pe) return de;
  Pe = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function t(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, u = 0; u < 10; u++)
        a["_" + String.fromCharCode(u)] = u;
      var d = Object.getOwnPropertyNames(a).map(function(y) {
        return a[y];
      });
      if (d.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(y) {
        p[y] = y;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return de = i() ? Object.assign : function(o, a) {
    for (var u, d = t(o), p, y = 1; y < arguments.length; y++) {
      u = Object(arguments[y]);
      for (var b in u)
        n.call(u, b) && (d[b] = u[b]);
      if (e) {
        p = e(u);
        for (var x = 0; x < p.length; x++)
          r.call(u, p[x]) && (d[p[x]] = u[p[x]]);
      }
    }
    return d;
  }, de;
}
var pe, we;
function Re() {
  if (we) return pe;
  we = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return pe = e, pe;
}
var ye, Ae;
function Ye() {
  return Ae || (Ae = 1, ye = Function.call.bind(Object.prototype.hasOwnProperty)), ye;
}
var be, Ie;
function at() {
  if (Ie) return be;
  Ie = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var n = Re(), r = {}, t = Ye();
    e = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, u, d, p) {
    if (process.env.NODE_ENV !== "production") {
      for (var y in o)
        if (t(o, y)) {
          var b;
          try {
            if (typeof o[y] != "function") {
              var x = Error(
                (d || "React class") + ": " + u + " type `" + y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[y] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw x.name = "Invariant Violation", x;
            }
            b = o[y](a, y, d, u, null, n);
          } catch (h) {
            b = h;
          }
          if (b && !(b instanceof Error) && e(
            (d || "React class") + ": type specification of " + u + " `" + y + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof b + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), b instanceof Error && !(b.message in r)) {
            r[b.message] = !0;
            var C = p ? p() : "";
            e(
              "Failed " + u + " type: " + b.message + (C ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, be = i, be;
}
var me, ke;
function ct() {
  if (ke) return me;
  ke = 1;
  var e = qe(), n = st(), r = Re(), t = Ye(), i = at(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(u) {
    var d = "Warning: " + u;
    typeof console < "u" && console.error(d);
    try {
      throw new Error(d);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return me = function(u, d) {
    var p = typeof Symbol == "function" && Symbol.iterator, y = "@@iterator";
    function b(s) {
      var f = s && (p && s[p] || s[y]);
      if (typeof f == "function")
        return f;
    }
    var x = "<<anonymous>>", C = {
      array: F("array"),
      bigint: F("bigint"),
      bool: F("boolean"),
      func: F("function"),
      number: F("number"),
      object: F("object"),
      string: F("string"),
      symbol: F("symbol"),
      any: B(),
      arrayOf: m,
      element: $(),
      elementType: c(),
      instanceOf: W,
      node: U(),
      objectOf: Y,
      oneOf: L,
      oneOfType: z,
      shape: X,
      exact: J
    };
    function h(s, f) {
      return s === f ? s !== 0 || 1 / s === 1 / f : s !== s && f !== f;
    }
    function O(s, f) {
      this.message = s, this.data = f && typeof f == "object" ? f : {}, this.stack = "";
    }
    O.prototype = Error.prototype;
    function j(s) {
      if (process.env.NODE_ENV !== "production")
        var f = {}, v = 0;
      function E(A, _, S, I, D, k, V) {
        if (I = I || x, k = k || S, V !== r) {
          if (d) {
            var l = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw l.name = "Invariant Violation", l;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Z = I + ":" + S;
            !f[Z] && // Avoid spamming the console because they are often not actionable except for lib authors
            v < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + k + "` prop on `" + I + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), f[Z] = !0, v++);
          }
        }
        return _[S] == null ? A ? _[S] === null ? new O("The " + D + " `" + k + "` is marked as required " + ("in `" + I + "`, but its value is `null`.")) : new O("The " + D + " `" + k + "` is marked as required in " + ("`" + I + "`, but its value is `undefined`.")) : null : s(_, S, I, D, k);
      }
      var g = E.bind(null, !1);
      return g.isRequired = E.bind(null, !0), g;
    }
    function F(s) {
      function f(v, E, g, A, _, S) {
        var I = v[E], D = P(I);
        if (D !== s) {
          var k = w(I);
          return new O(
            "Invalid " + A + " `" + _ + "` of type " + ("`" + k + "` supplied to `" + g + "`, expected ") + ("`" + s + "`."),
            { expectedType: s }
          );
        }
        return null;
      }
      return j(f);
    }
    function B() {
      return j(a);
    }
    function m(s) {
      function f(v, E, g, A, _) {
        if (typeof s != "function")
          return new O("Property `" + _ + "` of component `" + g + "` has invalid PropType notation inside arrayOf.");
        var S = v[E];
        if (!Array.isArray(S)) {
          var I = P(S);
          return new O("Invalid " + A + " `" + _ + "` of type " + ("`" + I + "` supplied to `" + g + "`, expected an array."));
        }
        for (var D = 0; D < S.length; D++) {
          var k = s(S, D, g, A, _ + "[" + D + "]", r);
          if (k instanceof Error)
            return k;
        }
        return null;
      }
      return j(f);
    }
    function $() {
      function s(f, v, E, g, A) {
        var _ = f[v];
        if (!u(_)) {
          var S = P(_);
          return new O("Invalid " + g + " `" + A + "` of type " + ("`" + S + "` supplied to `" + E + "`, expected a single ReactElement."));
        }
        return null;
      }
      return j(s);
    }
    function c() {
      function s(f, v, E, g, A) {
        var _ = f[v];
        if (!e.isValidElementType(_)) {
          var S = P(_);
          return new O("Invalid " + g + " `" + A + "` of type " + ("`" + S + "` supplied to `" + E + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return j(s);
    }
    function W(s) {
      function f(v, E, g, A, _) {
        if (!(v[E] instanceof s)) {
          var S = s.name || x, I = ne(v[E]);
          return new O("Invalid " + A + " `" + _ + "` of type " + ("`" + I + "` supplied to `" + g + "`, expected ") + ("instance of `" + S + "`."));
        }
        return null;
      }
      return j(f);
    }
    function L(s) {
      if (!Array.isArray(s))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function f(v, E, g, A, _) {
        for (var S = v[E], I = 0; I < s.length; I++)
          if (h(S, s[I]))
            return null;
        var D = JSON.stringify(s, function(V, l) {
          var Z = w(l);
          return Z === "symbol" ? String(l) : l;
        });
        return new O("Invalid " + A + " `" + _ + "` of value `" + String(S) + "` " + ("supplied to `" + g + "`, expected one of " + D + "."));
      }
      return j(f);
    }
    function Y(s) {
      function f(v, E, g, A, _) {
        if (typeof s != "function")
          return new O("Property `" + _ + "` of component `" + g + "` has invalid PropType notation inside objectOf.");
        var S = v[E], I = P(S);
        if (I !== "object")
          return new O("Invalid " + A + " `" + _ + "` of type " + ("`" + I + "` supplied to `" + g + "`, expected an object."));
        for (var D in S)
          if (t(S, D)) {
            var k = s(S, D, g, A, _ + "." + D, r);
            if (k instanceof Error)
              return k;
          }
        return null;
      }
      return j(f);
    }
    function z(s) {
      if (!Array.isArray(s))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var f = 0; f < s.length; f++) {
        var v = s[f];
        if (typeof v != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + q(v) + " at index " + f + "."
          ), a;
      }
      function E(g, A, _, S, I) {
        for (var D = [], k = 0; k < s.length; k++) {
          var V = s[k], l = V(g, A, _, S, I, r);
          if (l == null)
            return null;
          l.data && t(l.data, "expectedType") && D.push(l.data.expectedType);
        }
        var Z = D.length > 0 ? ", expected one of type [" + D.join(", ") + "]" : "";
        return new O("Invalid " + S + " `" + I + "` supplied to " + ("`" + _ + "`" + Z + "."));
      }
      return j(E);
    }
    function U() {
      function s(f, v, E, g, A) {
        return H(f[v]) ? null : new O("Invalid " + g + " `" + A + "` supplied to " + ("`" + E + "`, expected a ReactNode."));
      }
      return j(s);
    }
    function G(s, f, v, E, g) {
      return new O(
        (s || "React class") + ": " + f + " type `" + v + "." + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + g + "`."
      );
    }
    function X(s) {
      function f(v, E, g, A, _) {
        var S = v[E], I = P(S);
        if (I !== "object")
          return new O("Invalid " + A + " `" + _ + "` of type `" + I + "` " + ("supplied to `" + g + "`, expected `object`."));
        for (var D in s) {
          var k = s[D];
          if (typeof k != "function")
            return G(g, A, _, D, w(k));
          var V = k(S, D, g, A, _ + "." + D, r);
          if (V)
            return V;
        }
        return null;
      }
      return j(f);
    }
    function J(s) {
      function f(v, E, g, A, _) {
        var S = v[E], I = P(S);
        if (I !== "object")
          return new O("Invalid " + A + " `" + _ + "` of type `" + I + "` " + ("supplied to `" + g + "`, expected `object`."));
        var D = n({}, v[E], s);
        for (var k in D) {
          var V = s[k];
          if (t(s, k) && typeof V != "function")
            return G(g, A, _, k, w(V));
          if (!V)
            return new O(
              "Invalid " + A + " `" + _ + "` key `" + k + "` supplied to `" + g + "`.\nBad object: " + JSON.stringify(v[E], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(s), null, "  ")
            );
          var l = V(S, k, g, A, _ + "." + k, r);
          if (l)
            return l;
        }
        return null;
      }
      return j(f);
    }
    function H(s) {
      switch (typeof s) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !s;
        case "object":
          if (Array.isArray(s))
            return s.every(H);
          if (s === null || u(s))
            return !0;
          var f = b(s);
          if (f) {
            var v = f.call(s), E;
            if (f !== s.entries) {
              for (; !(E = v.next()).done; )
                if (!H(E.value))
                  return !1;
            } else
              for (; !(E = v.next()).done; ) {
                var g = E.value;
                if (g && !H(g[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Q(s, f) {
      return s === "symbol" ? !0 : f ? f["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && f instanceof Symbol : !1;
    }
    function P(s) {
      var f = typeof s;
      return Array.isArray(s) ? "array" : s instanceof RegExp ? "object" : Q(f, s) ? "symbol" : f;
    }
    function w(s) {
      if (typeof s > "u" || s === null)
        return "" + s;
      var f = P(s);
      if (f === "object") {
        if (s instanceof Date)
          return "date";
        if (s instanceof RegExp)
          return "regexp";
      }
      return f;
    }
    function q(s) {
      var f = w(s);
      switch (f) {
        case "array":
        case "object":
          return "an " + f;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + f;
        default:
          return f;
      }
    }
    function ne(s) {
      return !s.constructor || !s.constructor.name ? x : s.constructor.name;
    }
    return C.checkPropTypes = i, C.resetWarningCache = i.resetWarningCache, C.PropTypes = C, C;
  }, me;
}
var ve, Ne;
function ut() {
  if (Ne) return ve;
  Ne = 1;
  var e = Re();
  function n() {
  }
  function r() {
  }
  return r.resetWarningCache = n, ve = function() {
    function t(a, u, d, p, y, b) {
      if (b !== e) {
        var x = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw x.name = "Invariant Violation", x;
      }
    }
    t.isRequired = t;
    function i() {
      return t;
    }
    var o = {
      array: t,
      bigint: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: i,
      element: t,
      elementType: t,
      instanceOf: i,
      node: t,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: n
    };
    return o.PropTypes = o, o;
  }, ve;
}
if (process.env.NODE_ENV !== "production") {
  var lt = qe(), ft = !0;
  Ee.exports = ct()(lt.isElement, ft);
} else
  Ee.exports = ut()();
var dt = Ee.exports;
const T = /* @__PURE__ */ nt(dt);
function We(e, n) {
  return process.env.NODE_ENV === "production" ? () => null : function(...t) {
    return e(...t) || n(...t);
  };
}
function pt(e) {
  const {
    prototype: n = {}
  } = e;
  return !!n.isReactComponent;
}
function Ue(e, n, r, t, i) {
  const o = e[n], a = i || n;
  if (o == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let u;
  const d = o.type;
  return typeof d == "function" && !pt(d) && (u = "Did you accidentally use a plain function component for an element instead?"), u !== void 0 ? new Error(`Invalid ${t} \`${a}\` supplied to \`${r}\`. Expected an element that can hold a ref. ${u} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const xe = We(T.element, Ue);
xe.isRequired = We(T.element.isRequired, Ue);
const yt = "exact-prop: ​";
function Ve(e) {
  return process.env.NODE_ENV === "production" ? e : {
    ...e,
    [yt]: (n) => {
      const r = Object.keys(n).filter((t) => !e.hasOwnProperty(t));
      return r.length > 0 ? new Error(`The following props are not supported: ${r.map((t) => `\`${t}\``).join(", ")}. Please remove them.`) : null;
    }
  };
}
function Be(e, n, r, t, i) {
  if (process.env.NODE_ENV === "production")
    return null;
  const o = e[n], a = i || n;
  return o == null ? null : o && o.nodeType !== 1 ? new Error(`Invalid ${t} \`${a}\` supplied to \`${r}\`. Expected an HTMLElement.`) : null;
}
function Me(...e) {
  return e.reduce((n, r) => r == null ? n : function(...i) {
    n.apply(this, i), r.apply(this, i);
  }, () => {
  });
}
function te(e) {
  return e && e.ownerDocument || document;
}
function ce(e) {
  return te(e).defaultView || window;
}
function ge(e, n) {
  typeof e == "function" ? e(n) : e && (e.current = n);
}
const Te = typeof window < "u" ? R.useLayoutEffect : R.useEffect;
function $e(e) {
  const n = R.useRef(e);
  return Te(() => {
    n.current = e;
  }), R.useRef((...r) => (
    // @ts-expect-error hide `this`
    (0, n.current)(...r)
  )).current;
}
function fe(...e) {
  return R.useMemo(() => e.every((n) => n == null) ? null : (n) => {
    e.forEach((r) => {
      ge(r, n);
    });
  }, e);
}
function bt(e = window) {
  const n = e.document.documentElement.clientWidth;
  return e.innerWidth - n;
}
function mt(e, n, r = void 0) {
  const t = {};
  for (const i in e) {
    const o = e[i];
    let a = "", u = !0;
    for (let d = 0; d < o.length; d += 1) {
      const p = o[d];
      p && (a += (u === !0 ? "" : " ") + n(p), u = !1, r && r[p] && (a += " " + r[p]));
    }
    t[i] = a;
  }
  return t;
}
const vt = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function ht(e) {
  return typeof e == "string";
}
function Et(e, n, r) {
  return e === void 0 || ht(e) ? n : {
    ...n,
    ownerState: {
      ...n.ownerState,
      ...r
    }
  };
}
function He(e, n = []) {
  if (e === void 0)
    return {};
  const r = {};
  return Object.keys(e).filter((t) => t.match(/^on[A-Z]/) && typeof e[t] == "function" && !n.includes(t)).forEach((t) => {
    r[t] = e[t];
  }), r;
}
function De(e) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => !(r.match(/^on[A-Z]/) && typeof e[r] == "function")).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function gt(e) {
  const {
    getSlotProps: n,
    additionalProps: r,
    externalSlotProps: t,
    externalForwardedProps: i,
    className: o
  } = e;
  if (!n) {
    const C = re(r == null ? void 0 : r.className, o, i == null ? void 0 : i.className, t == null ? void 0 : t.className), h = {
      ...r == null ? void 0 : r.style,
      ...i == null ? void 0 : i.style,
      ...t == null ? void 0 : t.style
    }, O = {
      ...r,
      ...i,
      ...t
    };
    return C.length > 0 && (O.className = C), Object.keys(h).length > 0 && (O.style = h), {
      props: O,
      internalRef: void 0
    };
  }
  const a = He({
    ...i,
    ...t
  }), u = De(t), d = De(i), p = n(a), y = re(p == null ? void 0 : p.className, r == null ? void 0 : r.className, o, i == null ? void 0 : i.className, t == null ? void 0 : t.className), b = {
    ...p == null ? void 0 : p.style,
    ...r == null ? void 0 : r.style,
    ...i == null ? void 0 : i.style,
    ...t == null ? void 0 : t.style
  }, x = {
    ...p,
    ...r,
    ...d,
    ...u
  };
  return y.length > 0 && (x.className = y), Object.keys(b).length > 0 && (x.style = b), {
    props: x,
    internalRef: p.ref
  };
}
function Tt(e, n, r) {
  return typeof e == "function" ? e(n, r) : e;
}
function je(e) {
  var b;
  const {
    elementType: n,
    externalSlotProps: r,
    ownerState: t,
    skipResolvingSlotProps: i = !1,
    ...o
  } = e, a = i ? {} : Tt(r, t), {
    props: u,
    internalRef: d
  } = gt({
    ...o,
    externalSlotProps: a
  }), p = fe(d, a == null ? void 0 : a.ref, (b = e.additionalProps) == null ? void 0 : b.ref);
  return Et(n, {
    ...u,
    ref: p
  }, t);
}
function Ke(e) {
  var n;
  return parseInt(R.version, 10) >= 19 ? ((n = e == null ? void 0 : e.props) == null ? void 0 : n.ref) || null : (e == null ? void 0 : e.ref) || null;
}
const Rt = {
  disableDefaultClasses: !1
}, ze = /* @__PURE__ */ R.createContext(Rt);
process.env.NODE_ENV !== "production" && (ze.displayName = "ClassNameConfiguratorContext");
function xt(e) {
  const {
    disableDefaultClasses: n
  } = R.useContext(ze);
  return (r) => n ? "" : e(r);
}
function _t(e) {
  return typeof e == "function" ? e() : e;
}
const ue = /* @__PURE__ */ R.forwardRef(function(n, r) {
  const {
    children: t,
    container: i,
    disablePortal: o = !1
  } = n, [a, u] = R.useState(null), d = fe(/* @__PURE__ */ R.isValidElement(t) ? Ke(t) : null, r);
  if (Te(() => {
    o || u(_t(i) || document.body);
  }, [i, o]), Te(() => {
    if (a && !o)
      return ge(r, a), () => {
        ge(r, null);
      };
  }, [r, a, o]), o) {
    if (/* @__PURE__ */ R.isValidElement(t)) {
      const p = {
        ref: d
      };
      return /* @__PURE__ */ R.cloneElement(t, p);
    }
    return /* @__PURE__ */ K(R.Fragment, {
      children: t
    });
  }
  return /* @__PURE__ */ K(R.Fragment, {
    children: a && /* @__PURE__ */ rt.createPortal(t, a)
  });
});
process.env.NODE_ENV !== "production" && (ue.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: T.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: T.oneOfType([Be, T.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: T.bool
});
process.env.NODE_ENV !== "production" && (ue.propTypes = Ve(ue.propTypes));
function St(e) {
  const n = te(e);
  return n.body === e ? ce(e).innerWidth > n.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function oe(e, n) {
  n ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function Fe(e) {
  return parseInt(ce(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function Ct(e) {
  const r = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].includes(e.tagName), t = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return r || t;
}
function Le(e, n, r, t, i) {
  const o = [n, r, ...t];
  [].forEach.call(e.children, (a) => {
    const u = !o.includes(a), d = !Ct(a);
    u && d && oe(a, i);
  });
}
function he(e, n) {
  let r = -1;
  return e.some((t, i) => n(t) ? (r = i, !0) : !1), r;
}
function Ot(e, n) {
  const r = [], t = e.container;
  if (!n.disableScrollLock) {
    if (St(t)) {
      const a = bt(ce(t));
      r.push({
        value: t.style.paddingRight,
        property: "padding-right",
        el: t
      }), t.style.paddingRight = `${Fe(t) + a}px`;
      const u = te(t).querySelectorAll(".mui-fixed");
      [].forEach.call(u, (d) => {
        r.push({
          value: d.style.paddingRight,
          property: "padding-right",
          el: d
        }), d.style.paddingRight = `${Fe(d) + a}px`;
      });
    }
    let o;
    if (t.parentNode instanceof DocumentFragment)
      o = te(t).body;
    else {
      const a = t.parentElement, u = ce(t);
      o = (a == null ? void 0 : a.nodeName) === "HTML" && u.getComputedStyle(a).overflowY === "scroll" ? a : t;
    }
    r.push({
      value: o.style.overflow,
      property: "overflow",
      el: o
    }, {
      value: o.style.overflowX,
      property: "overflow-x",
      el: o
    }, {
      value: o.style.overflowY,
      property: "overflow-y",
      el: o
    }), o.style.overflow = "hidden";
  }
  return () => {
    r.forEach(({
      value: o,
      el: a,
      property: u
    }) => {
      o ? a.style.setProperty(u, o) : a.style.removeProperty(u);
    });
  };
}
function Pt(e) {
  const n = [];
  return [].forEach.call(e.children, (r) => {
    r.getAttribute("aria-hidden") === "true" && n.push(r);
  }), n;
}
class wt {
  constructor() {
    this.modals = [], this.containers = [];
  }
  add(n, r) {
    let t = this.modals.indexOf(n);
    if (t !== -1)
      return t;
    t = this.modals.length, this.modals.push(n), n.modalRef && oe(n.modalRef, !1);
    const i = Pt(r);
    Le(r, n.mount, n.modalRef, i, !0);
    const o = he(this.containers, (a) => a.container === r);
    return o !== -1 ? (this.containers[o].modals.push(n), t) : (this.containers.push({
      modals: [n],
      container: r,
      restore: null,
      hiddenSiblings: i
    }), t);
  }
  mount(n, r) {
    const t = he(this.containers, (o) => o.modals.includes(n)), i = this.containers[t];
    i.restore || (i.restore = Ot(i, r));
  }
  remove(n, r = !0) {
    const t = this.modals.indexOf(n);
    if (t === -1)
      return t;
    const i = he(this.containers, (a) => a.modals.includes(n)), o = this.containers[i];
    if (o.modals.splice(o.modals.indexOf(n), 1), this.modals.splice(t, 1), o.modals.length === 0)
      o.restore && o.restore(), n.modalRef && oe(n.modalRef, r), Le(o.container, n.mount, n.modalRef, o.hiddenSiblings, !1), this.containers.splice(i, 1);
    else {
      const a = o.modals[o.modals.length - 1];
      a.modalRef && oe(a.modalRef, !1);
    }
    return t;
  }
  isTopModal(n) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === n;
  }
}
function At(e) {
  return typeof e == "function" ? e() : e;
}
function It(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const kt = new wt();
function Nt(e) {
  const {
    container: n,
    disableEscapeKeyDown: r = !1,
    disableScrollLock: t = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: i = kt,
    closeAfterTransition: o = !1,
    onTransitionEnter: a,
    onTransitionExited: u,
    children: d,
    onClose: p,
    open: y,
    rootRef: b
  } = e, x = R.useRef({}), C = R.useRef(null), h = R.useRef(null), O = fe(h, b), [j, F] = R.useState(!y), B = It(d);
  let m = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (m = !1);
  const $ = () => te(C.current), c = () => (x.current.modalRef = h.current, x.current.mount = C.current, x.current), W = () => {
    i.mount(c(), {
      disableScrollLock: t
    }), h.current && (h.current.scrollTop = 0);
  }, L = $e(() => {
    const P = At(n) || $().body;
    i.add(c(), P), h.current && W();
  }), Y = R.useCallback(() => i.isTopModal(c()), [i]), z = $e((P) => {
    C.current = P, P && (y && Y() ? W() : h.current && oe(h.current, m));
  }), U = R.useCallback(() => {
    i.remove(c(), m);
  }, [m, i]);
  R.useEffect(() => () => {
    U();
  }, [U]), R.useEffect(() => {
    y ? L() : (!B || !o) && U();
  }, [y, U, B, o, L]);
  const G = (P) => (w) => {
    var q;
    (q = P.onKeyDown) == null || q.call(P, w), !(w.key !== "Escape" || w.which === 229 || // Wait until IME is settled.
    !Y()) && (r || (w.stopPropagation(), p && p(w, "escapeKeyDown")));
  }, X = (P) => (w) => {
    var q;
    (q = P.onClick) == null || q.call(P, w), w.target === w.currentTarget && p && p(w, "backdropClick");
  };
  return {
    getRootProps: (P = {}) => {
      const w = He(e);
      delete w.onTransitionEnter, delete w.onTransitionExited;
      const q = {
        ...w,
        ...P
      };
      return {
        /*
         * Marking an element with the role presentation indicates to assistive technology
         * that this element should be ignored; it exists to support the web application and
         * is not meant for humans to interact with directly.
         * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
         */
        role: "presentation",
        ...q,
        onKeyDown: G(q),
        ref: O
      };
    },
    getBackdropProps: (P = {}) => {
      const w = P;
      return {
        "aria-hidden": !0,
        ...w,
        onClick: X(w),
        open: y
      };
    },
    getTransitionProps: () => {
      const P = () => {
        F(!1), a && a();
      }, w = () => {
        F(!0), u && u(), o && U();
      };
      return {
        onEnter: Me(P, d == null ? void 0 : d.props.onEnter),
        onExited: Me(w, d == null ? void 0 : d.props.onExited)
      };
    },
    rootRef: O,
    portalRef: z,
    isTopModal: Y,
    exited: j,
    hasTransition: B
  };
}
const Mt = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function $t(e) {
  const n = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(n) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : n;
}
function Dt(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const n = (t) => e.ownerDocument.querySelector(`input[type="radio"]${t}`);
  let r = n(`[name="${e.name}"]:checked`);
  return r || (r = n(`[name="${e.name}"]`)), r !== e;
}
function jt(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || Dt(e));
}
function Ft(e) {
  const n = [], r = [];
  return Array.from(e.querySelectorAll(Mt)).forEach((t, i) => {
    const o = $t(t);
    o === -1 || !jt(t) || (o === 0 ? n.push(t) : r.push({
      documentOrder: i,
      tabIndex: o,
      node: t
    }));
  }), r.sort((t, i) => t.tabIndex === i.tabIndex ? t.documentOrder - i.documentOrder : t.tabIndex - i.tabIndex).map((t) => t.node).concat(n);
}
function Lt() {
  return !0;
}
function le(e) {
  const {
    children: n,
    disableAutoFocus: r = !1,
    disableEnforceFocus: t = !1,
    disableRestoreFocus: i = !1,
    getTabbable: o = Ft,
    isEnabled: a = Lt,
    open: u
  } = e, d = R.useRef(!1), p = R.useRef(null), y = R.useRef(null), b = R.useRef(null), x = R.useRef(null), C = R.useRef(!1), h = R.useRef(null), O = fe(Ke(n), h), j = R.useRef(null);
  R.useEffect(() => {
    !u || !h.current || (C.current = !r);
  }, [r, u]), R.useEffect(() => {
    if (!u || !h.current)
      return;
    const m = te(h.current);
    return h.current.contains(m.activeElement) || (h.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), h.current.setAttribute("tabIndex", "-1")), C.current && h.current.focus()), () => {
      i || (b.current && b.current.focus && (d.current = !0, b.current.focus()), b.current = null);
    };
  }, [u]), R.useEffect(() => {
    if (!u || !h.current)
      return;
    const m = te(h.current), $ = (L) => {
      j.current = L, !(t || !a() || L.key !== "Tab") && m.activeElement === h.current && L.shiftKey && (d.current = !0, y.current && y.current.focus());
    }, c = () => {
      var z, U;
      const L = h.current;
      if (L === null)
        return;
      if (!m.hasFocus() || !a() || d.current) {
        d.current = !1;
        return;
      }
      if (L.contains(m.activeElement) || t && m.activeElement !== p.current && m.activeElement !== y.current)
        return;
      if (m.activeElement !== x.current)
        x.current = null;
      else if (x.current !== null)
        return;
      if (!C.current)
        return;
      let Y = [];
      if ((m.activeElement === p.current || m.activeElement === y.current) && (Y = o(h.current)), Y.length > 0) {
        const G = !!((z = j.current) != null && z.shiftKey && ((U = j.current) == null ? void 0 : U.key) === "Tab"), X = Y[0], J = Y[Y.length - 1];
        typeof X != "string" && typeof J != "string" && (G ? J.focus() : X.focus());
      } else
        L.focus();
    };
    m.addEventListener("focusin", c), m.addEventListener("keydown", $, !0);
    const W = setInterval(() => {
      m.activeElement && m.activeElement.tagName === "BODY" && c();
    }, 50);
    return () => {
      clearInterval(W), m.removeEventListener("focusin", c), m.removeEventListener("keydown", $, !0);
    };
  }, [r, t, i, a, u, o]);
  const F = (m) => {
    b.current === null && (b.current = m.relatedTarget), C.current = !0, x.current = m.target;
    const $ = n.props.onFocus;
    $ && $(m);
  }, B = (m) => {
    b.current === null && (b.current = m.relatedTarget), C.current = !0;
  };
  return /* @__PURE__ */ ae(R.Fragment, {
    children: [/* @__PURE__ */ K("div", {
      tabIndex: u ? 0 : -1,
      onFocus: B,
      ref: p,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ R.cloneElement(n, {
      ref: O,
      onFocus: F
    }), /* @__PURE__ */ K("div", {
      tabIndex: u ? 0 : -1,
      onFocus: B,
      ref: y,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (le.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: xe,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: T.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: T.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: T.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: T.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: T.func,
  /**
   * If `true`, focus is locked.
   */
  open: T.bool.isRequired
});
process.env.NODE_ENV !== "production" && (le.propTypes = Ve(le.propTypes));
const Ge = "base";
function qt(e) {
  return `${Ge}--${e}`;
}
function Yt(e, n) {
  return `${Ge}-${e}-${n}`;
}
function Xe(e, n) {
  const r = vt[n];
  return r ? qt(r) : Yt(e, n);
}
function Wt(e, n) {
  const r = {};
  return n.forEach((t) => {
    r[t] = Xe(e, t);
  }), r;
}
const Je = "Modal";
function Ut(e) {
  return Xe(Je, e);
}
Wt(Je, ["root", "hidden", "backdrop"]);
const Vt = (e) => {
  const {
    open: n,
    exited: r
  } = e;
  return mt({
    root: ["root", !n && r && "hidden"],
    backdrop: ["backdrop"]
  }, xt(Ut));
}, Ze = /* @__PURE__ */ R.forwardRef(function(n, r) {
  const {
    children: t,
    closeAfterTransition: i = !1,
    container: o,
    disableAutoFocus: a = !1,
    disableEnforceFocus: u = !1,
    disableEscapeKeyDown: d = !1,
    disablePortal: p = !1,
    disableRestoreFocus: y = !1,
    disableScrollLock: b = !1,
    hideBackdrop: x = !1,
    keepMounted: C = !1,
    onBackdropClick: h,
    onClose: O,
    onKeyDown: j,
    open: F,
    onTransitionEnter: B,
    onTransitionExited: m,
    slotProps: $ = {},
    slots: c = {},
    ...W
  } = n, L = {
    ...n,
    closeAfterTransition: i,
    disableAutoFocus: a,
    disableEnforceFocus: u,
    disableEscapeKeyDown: d,
    disablePortal: p,
    disableRestoreFocus: y,
    disableScrollLock: b,
    hideBackdrop: x,
    keepMounted: C
  }, {
    getRootProps: Y,
    getBackdropProps: z,
    getTransitionProps: U,
    portalRef: G,
    isTopModal: X,
    exited: J,
    hasTransition: H
  } = Nt({
    ...L,
    rootRef: r
  }), Q = {
    ...L,
    exited: J,
    hasTransition: H
  }, P = Vt(Q), w = {};
  if (t.props.tabIndex === void 0 && (w.tabIndex = "-1"), H) {
    const {
      onEnter: v,
      onExited: E
    } = U();
    w.onEnter = v, w.onExited = E;
  }
  const q = c.root ?? "div", ne = je({
    elementType: q,
    externalSlotProps: $.root,
    externalForwardedProps: W,
    getSlotProps: Y,
    className: P.root,
    ownerState: Q
  }), s = c.backdrop, f = je({
    elementType: s,
    externalSlotProps: $.backdrop,
    getSlotProps: (v) => z({
      ...v,
      onClick: (E) => {
        h && h(E), v != null && v.onClick && v.onClick(E);
      }
    }),
    className: P.backdrop,
    ownerState: Q
  });
  return !C && !F && (!H || J) ? null : /* @__PURE__ */ K(ue, {
    ref: G,
    container: o,
    disablePortal: p,
    children: /* @__PURE__ */ ae(q, {
      ...ne,
      children: [!x && s ? /* @__PURE__ */ K(s, {
        ...f
      }) : null, /* @__PURE__ */ K(le, {
        disableEnforceFocus: u,
        disableAutoFocus: a,
        disableRestoreFocus: y,
        isEnabled: X,
        open: F,
        children: /* @__PURE__ */ R.cloneElement(t, w)
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (Ze.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: xe.isRequired,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: T.bool,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: T.oneOfType([Be, T.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: T.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: T.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: T.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: T.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: T.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: T.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: T.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: T.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: T.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: T.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: T.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: T.func,
  /**
   * If `true`, the component is shown.
   */
  open: T.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: T.shape({
    backdrop: T.oneOfType([T.func, T.object]),
    root: T.oneOfType([T.func, T.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: T.shape({
    backdrop: T.elementType,
    root: T.elementType
  })
});
const Bt = "elo-modal", Ht = "elo-modal__small", Kt = "elo-modal__lightbox", zt = "elo-modal__backdrop", ee = {
  modal: Bt,
  modal__small: Ht,
  modal__lightbox: Kt,
  modal__backdrop: zt,
  "modal__close-btn": "elo-modal__close-btn",
  "modal__close-btn--small": "elo-modal__close-btn--small",
  "modal__close-btn--lightbox": "elo-modal__close-btn--lightbox"
}, Qt = tt(
  ({
    modalAriaDescription: e,
    modalAriaTitle: n,
    isOpen: r,
    onClose: t,
    children: i,
    size: o = "lightbox",
    className: a,
    contentClass: u,
    displayCloseBtn: d = !0,
    ...p
  }, y) => {
    const b = re(
      {
        [ee.modal__small]: o === "small",
        [ee.modal__lightbox]: o === "lightbox"
      },
      u
    ), x = re(ee["modal__close-btn"], {
      [ee["modal__close-btn--small"]]: o === "small",
      [ee["modal__close-btn--lightbox"]]: o === "lightbox"
    });
    return /* @__PURE__ */ K(
      Ze,
      {
        ref: y,
        open: r,
        onClose: t,
        "aria-labelledby": n,
        "aria-describedby": e,
        className: re(ee.modal, a),
        "aria-expanded": r,
        "aria-hidden": !r,
        "aria-modal": "true",
        role: "dialog",
        ...p,
        children: /* @__PURE__ */ ae(Qe, { children: [
          o !== "lightbox" && /* @__PURE__ */ K("div", { className: ee.modal__backdrop, onClick: t }),
          /* @__PURE__ */ ae("div", { className: b, children: [
            d && /* @__PURE__ */ K(
              "button",
              {
                className: x,
                "aria-label": "Close Modal",
                onClick: t,
                children: /* @__PURE__ */ K(et, { name: "Close", height: "24", width: "24" })
              }
            ),
            i
          ] })
        ] })
      }
    );
  }
);
export {
  Be as H,
  Qt as M,
  T as P,
  Xe as a,
  ue as b,
  We as c,
  Te as d,
  je as e,
  mt as f,
  Wt as g,
  xt as h,
  $e as i,
  te as o,
  ge as s,
  fe as u
};
